import { Icon } from "semantic-ui-react";

import { PointsOfContactTableActions } from "./PointsOfContactTableActions";

export const getPointsOfContactTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Enabled",
      id: "Enabled",
      accessorKey: "enabled",
      cell: ({ row }) => (
        <Icon
          name={row.original?.enabled ? "check" : "close"}
          color={row.original?.enabled ? "green" : "red"}
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <PointsOfContactTableActions original={row.original} />
      ),
    },
  ];
};
